export default __webpack_public_path__ + "static/media/Premios SUME Homero 1500 rev 1.1af4d2df.pdf";